import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import arrowleft from "../assets/images/arrow-left.png";
import DropdownRight from "./DropdownRight";
import { useLocation, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import http from "../services/http";
import GetStorage from "../services/Storage";
import { ToastContainer } from "react-toastify";
import { showToast } from "./ShowToast";
import ReactInputMask from "react-input-mask";
import DatePicker from "react-datepicker";
import visable from "../assets/images/visibility.png";
import unvisable from "../assets/images/unvisibility.png";

function MasterKey(props) {

    const location = useLocation();
    const navigate = useNavigate();

    const token = GetStorage.get("xAuthToken");

    const [error, setError] = useState("");
    const [masterKeyDetails, setMasterKeyDetails] = useState({});
    const [passwordType, setPasswordType] = useState("password");



    const onSubmit = async (values) => {

        http
            .put(`api/admin/master-key/1?token=${token}`, {
                master_key: masterKeyDetails.master_key
            })
            .then((res) => {
                showToast("success", res.data.message);
                setTimeout(() => {
                    navigate(-1);
                }, 3000);
            })
            .catch((error) => {
                if (error.response) {
                    if (error.response.data.errors) {
                        for (let key in error.response.data.errors) {
                            setError(error.response.data.errors[key]);
                            showToast("error", error.response.data.errors[key]);
                        }
                    } else if (error.response.data.message) {
                        showToast("error", error.response.data.message);

                        setError(error.response.data.message);
                    }
                }
            });
    };

    const onChangeProp = (event, key) => {
        masterKeyDetails[key] = event.target.value
        setMasterKeyDetails(masterKeyDetails);
    };

    const togglePassword = () => {
        if (passwordType === "password") {
          setPasswordType("text");
          return;
        }
        setPasswordType("password");
    };

    return (
        <>
            <body>
                <div className="wrapper">
                    <Nav />
                    <div id="content">
                        <header>
                            <div className="dashboard_header">
                                <div className="left-side d-flex ">
                                    <button
                                        onClick={() => navigate(-1)}
                                        type="button"
                                        id="sidebarCollapse"
                                        className="btn btn-link  "
                                    >
                                        <img src={arrowleft} className="img-fluid" />{" "}
                                    </button>
                                    <h1>Update Master Key</h1>{" "}
                                </div>
                                <DropdownRight />
                            </div>
                        </header>

                        <Formik
                            initialValues={masterKeyDetails}
                            onSubmit={onSubmit}>
                            {({ values, handleSubmit, setFieldValue, handleChange }) => (
                                <>
                                    <div className="dashbord_content">
                                        <div className="dashobord_inner new_team_add mt-5">
                                            <form onSubmit={handleSubmit}>
                                                <div className="row">
                                                    <div className="col-md-4 col-sm-6">
                                                        <div className="fomr-group">
                                                            <label>Master Key</label>
                                                            <input
                                                                name="master_key"
                                                                type={passwordType}
                                                                id="master_key"
                                                                onChange={(e) => {
                                                                    handleChange(e);
                                                                    onChangeProp(e, "master_key")
                                                                }}
                                                                value={masterKeyDetails.master_key}
                                                                placeholder="Enter Master Key"
                                                                className="custom_input form-control"
                                                            />
                                                            <div class="password_eye_img_icon">
                                                                {passwordType === "password" ? (
                                                                    <a>
                                                                        <img src={visable} alt="" onClick={togglePassword} />
                                                                    </a>
                                                                ) : (
                                                                    <a>
                                                                        <img
                                                                            src={unvisable}
                                                                            alt=""
                                                                            onClick={togglePassword}
                                                                        />{" "}
                                                                    </a>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-12 d-flex justify-content-end">
                                                        <div className="btn_wraper d-flex Permissions_text align-item-center mt_40 mb_30">
                                                            <button
                                                                onClick={() => navigate(-1)}
                                                                type="button"
                                                                className=" them_btn_ouline  "
                                                            >
                                                                Cancel
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="them_btn "
                                                                onClick={onSubmit}
                                                            >
                                                                Save
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Formik>
                    </div>
                </div>
            </body>
            <ToastContainer />
        </>
    );
}

export default MasterKey;
